'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notes = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A Note provider to help with store based notes
 * @private
 * @param {Object} props
 * @param {(ReactElement|ReactElement[])} props.children
 */
var NoteProvider = function NoteProvider(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    _react.Children.toArray(children).map(function (child, i) {
      return (0, _react.cloneElement)(child, { key: i });
    })
  );
};

/**
 * @private
 */
NoteProvider.propTypes = {
  children: _propTypes2.default.node

  /**
   * @private
   */
};NoteProvider.defaultProps = {
  children: null
};

exports.default = NoteProvider;

/**
 * A Notes section for the speaker
 * @private
 */

var Notes = exports.Notes = _styledComponents2.default.div.withConfig({
  displayName: 'notes__Notes'
})(['position:relative;height:100%;width:100%;padding:1rem;box-sizing:border-box;grid-area:Notes;background:#fff;color:#000;box-shadow:0 3px 8px rgba(0,0,0,0.7);border-radius:3px;overflow:hidden;font-size:2rem;']);